import React, { useState, useEffect } from 'react';
import { Bird, RefreshCw } from 'lucide-react';
import apiService from '../services/api';

const ChickenPicturePage = () => {
  const [currentChicken, setCurrentChicken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalViewed, setTotalViewed] = useState(0);

  const getRandomChicken = async () => {
    setLoading(true);
    try {
      const response = await apiService.getChickenPicture();
      setCurrentChicken(response);
      setTotalViewed(prev => prev + 1);
    } catch (error) {
      console.error('Error fetching chicken picture:', error);
      // Fallback chicken picture on error
      setCurrentChicken({
        url: 'https://images.unsplash.com/photo-1548550023-2bdb3c5beed7?w=800',
        width: 800,
        height: 600
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getRandomChicken();
  }, []);

  return (
    <div className="h-full flex flex-col bg-gradient-to-br from-yellow-50 to-orange-50 dark:from-gray-900 dark:to-yellow-900">
      {/* Header */}
      <div className="bg-gradient-to-r from-yellow-600 to-orange-600 text-white p-6">
        <div className="flex items-center gap-3 mb-2">
          <Bird className="h-8 w-8" />
          <h1 className="text-3xl font-bold">Hey Tomer! 🐔</h1>
        </div>
        <p className="text-yellow-100">Your daily dose of clucking adorableness</p>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-auto p-6">
        <div className="max-w-3xl mx-auto">
          {/* Chicken Picture Card */}
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden mb-6 border-4 border-yellow-200 dark:border-yellow-800">
            <div className="relative">
              {loading ? (
                <div className="flex items-center justify-center h-96 bg-gray-100 dark:bg-gray-700">
                  <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-yellow-600"></div>
                </div>
              ) : currentChicken ? (
                <img
                  src={currentChicken.url}
                  alt="Random chicken"
                  className="w-full h-auto object-cover"
                  style={{ maxHeight: '600px' }}
                  onError={(e) => {
                    e.target.src = 'https://images.unsplash.com/photo-1548550023-2bdb3c5beed7?w=800';
                  }}
                />
              ) : (
                <div className="flex items-center justify-center h-96 bg-gray-100 dark:bg-gray-700">
                  <Bird className="h-32 w-32 text-yellow-300 dark:text-yellow-600" />
                </div>
              )}
            </div>

            <div className="p-6">
              <button
                onClick={getRandomChicken}
                disabled={loading}
                className="w-full px-8 py-4 bg-gradient-to-r from-yellow-600 to-orange-600 text-white rounded-full font-semibold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-3"
              >
                <RefreshCw className={`h-5 w-5 ${loading ? 'animate-spin' : ''}`} />
                Get Another Chicken
              </button>
            </div>
          </div>

          {/* Fun Stats */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="bg-white dark:bg-gray-800 rounded-xl p-6 text-center shadow-lg border-2 border-yellow-100 dark:border-yellow-900">
              <div className="text-4xl font-bold text-yellow-600 dark:text-yellow-400">
                {totalViewed}
              </div>
              <div className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                Chickens Viewed
              </div>
            </div>
            <div className="bg-white dark:bg-gray-800 rounded-xl p-6 text-center shadow-lg border-2 border-orange-100 dark:border-orange-900">
              <div className="text-4xl font-bold text-orange-600 dark:text-orange-400">
                🐣
              </div>
              <div className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                Cuteness Level
              </div>
            </div>
            <div className="bg-white dark:bg-gray-800 rounded-xl p-6 text-center shadow-lg border-2 border-yellow-100 dark:border-yellow-900">
              <div className="text-4xl font-bold text-yellow-600 dark:text-yellow-400">
                🌾
              </div>
              <div className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                Farm Fresh
              </div>
            </div>
          </div>

          {/* Message */}
          <div className="mt-8 text-center">
            <p className="text-lg text-gray-600 dark:text-gray-400 italic">
              Keep clucking, Tomer! 🐓✨
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChickenPicturePage;
